import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListTotalTtcCell } from './emsp-bo-charging-session-list-total-ttc.cell';
import { EmspBoChargingSessionListTotalTtcHeader } from './emsp-bo-charging-session-list-total-ttc.header';

export const EmspBoChargingSessionListTotalTtcColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['totalTTC']
> = {
  enableSorting: true,
  header: EmspBoChargingSessionListTotalTtcHeader,
  cell: EmspBoChargingSessionListTotalTtcCell,
  meta: { maxWidth: '90px', width: '85px' },
};
